export default "__VITE_ASSET__DaTPlX3F__"